import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { ScrollRevealDirective } from '../../core/scroll-reveal.directive';
import { CountUpDirective } from '../../core/count-up.directive';

@Component({
    selector: 'app-hero',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LucideAngularModule, ScrollRevealDirective, CountUpDirective],
    templateUrl: './hero.component.html',
    styleUrl: './hero.component.scss'
})
export class HeroComponent {}
